export default "/fr/_next/static/assets/icons/apple/apple-touch-icon-fr-180x180.cf8b69fc661b231af02e2f685ad0133d.png";